export default __webpack_public_path__ + "static/media/4-2_image06@2x.46abd44e.png";